// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__uSj1V","head":"ProcedureTableInfo_head__iI8Jg"};